import axios from 'cheku-axios';
import { MessageBox } from 'element-ui';
import store from '../store/index';
import { API } from './config'
import Vue from 'vue'
import router from '../router';
// let baseURL = 'http://192.168.2.68/economic/';//ZQ;
let baseURL = API.baseURL;//ZQ;
axios.defaults.baseURL = baseURL;

// 请求拦截
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
return config;
    }, function (error) {
    // Do something with request error
    //做登录拦截
    return Promise.reject(error);
});

// 响应拦截
axios.interceptors.response.use(function (response) {
    // Do something with response data
    const { responseType } = response.config
    if (responseType === 'Binary' || responseType === 'blob') return res
      const res = response.data
      if(res.code === 200){
          return response.data;
      }else{
        switch(res.code){
          case 400:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 401:
          case 403:
        Vue.prototype.$message.closeAll();
        Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
        setTimeout(() => {
          window.localStorage.clear();
          store.commit({
            type:'user/loginOut'
          })
          router.push({
              path:'/login'
          })
        }, 1500)
        
          break;
          case 404:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 500:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
                  dangerouslyUseHTMLString:true
              });
          break;
        }
        if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
          return Promise.reject(new Error(res.msg || 'Error'))
        }else return  res
      }
    }, function (error) {
    // Do something with response error
	Vue.prototype.$message.closeAll();
   const code = error.response && error.response.status?error.response.status : error
    switch(code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 401:
        case 403:
                Vue.prototype.$message.closeAll();
                Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
                setTimeout(() => {
                    window.localStorage.clear();
                    router.replace('/login')
                }, 1500)
            // MessageBox({
            //     type: 'error',
            //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
            //     dangerouslyUseHTMLString:true
            // });
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！\n原因：服务器地址错误！`
            });
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！\n原因：服务端代码错误`
            });
        break;
    }
    return Promise.reject(error);
});



const axiosz = axios.create({
    // baseURL: 'http://192.168.2.68/economic/auth/server/',//朱庆请求地址
	baseURL:API.baseDataURL,//朱庆请求地址
  timeout: 500000,
});
// axiosz.defaults.withCredentials = true;
// 请求拦截
axiosz.interceptors.request.use(function (config) {
    // Do something before request is sent
    let token = store.state.user.token;
    if (token) {
      if(config.url !== 'rpc/verify/code' && config.url.indexOf('rpc/sysDict/parentId/') === -1)
      {
        config.headers['Authorization']=`Bearer ${token}`;
        config.headers['Content-Type']=`application/x-www-form-urlencoded`;
        // config.headers = {
        //   'Authorization': `Bearer ${token}`,
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // }
      }
    }
    return config;
    }, function (error) {
    // Do something with request error
    //做登录拦截
    return Promise.reject(error);
});

// 响应拦截
axiosz.interceptors.response.use(function (response) {
      // Do something with response data
      const res = response.data
      if(res.code === 200){
          return response.data;
      }else{
        switch(res.code){
          case 400:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 401:
          case 403:
        Vue.prototype.$message.closeAll();
        Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
        setTimeout(() => {
          window.localStorage.clear();
          store.commit({
            type:'user/loginOut'
          })
          router.push({
              path:'/login'
          })
        }, 1500)
        
          break;
          case 404:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 500:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
                  dangerouslyUseHTMLString:true
              });
          break;
        }
        if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
          return Promise.reject(new Error(res.msg || 'Error'))
        }else return  res
      }
      
    }, function (error) {
    const code = error.response && error.response.status?error.response.status:error
    // Do something with response error
	Vue.prototype.$message.closeAll();
    switch(code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 401:
          case 403:
			Vue.prototype.$message.closeAll();
			Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
			setTimeout(() => {
				window.localStorage.clear();
        store.commit({
          type:'user/loginOut'
        })
				router.push({
				    path:'/login'
				})
			}, 1500)
            // MessageBox({
            //     type: 'error',
            //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
            //     dangerouslyUseHTMLString:true
            // });
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${error.response.data.path}` ,
                dangerouslyUseHTMLString:true
            });
        break;
    }
    return Promise.reject(error);
});


const axiosc = axios.create({
    // baseURL: 'http://192.168.2.68/economic/review/server/',//朱庆请求地址
	baseURL: API.baseReviewURL,//朱庆请求地址
    timeout: 500000,
});
// axiosc.defaults.withCredentials = true;
// 请求拦截
axiosc.interceptors.request.use(function (config) {
    // Do something before request is sent
    let token = store.state.user.token;

    if (token) {
        config.headers['Authorization']=`Bearer ${token}`;
        config.headers['Content-Type']=`application/x-www-form-urlencoded`;
        // config.headers = {
        //   'Authorization': `Bearer ${token}`,
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // }
    }
    return config;
    }, function (error) {
    // Do something with request error
    //做登录拦截
    return Promise.reject(error);
});

// 响应拦截
axiosc.interceptors.response.use(function (response) {
      // Do something with response data
      const res = response.data
      if(res.code === 200){
          return response.data;
      }else{
        switch(res.code){
          case 400:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 401:
            case 403:
        Vue.prototype.$message.closeAll();
        Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
        setTimeout(() => {
          window.localStorage.clear();
          store.commit({
            type:'user/loginOut'
          })
          router.push({
              path:'/login'
          })
        }, 1500)
        
          break;
          case 404:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 500:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
                  dangerouslyUseHTMLString:true
              });
          break;
        }
        if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
          return Promise.reject(new Error(res.msg || 'Error'))
        }else return  res
      }
    }, function (error) {
		Vue.prototype.$message.closeAll();
    const code = error.response && error.response.status?error.response.status:error
    // Do something with response error
    switch(code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 401:
        case 403:
			Vue.prototype.$message.closeAll();
			Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
			setTimeout(() => {
				window.localStorage.clear();
        store.commit({
          type:'user/loginOut'
        })
				router.push({
				    path:'/login'
				})
			}, 1500)
            // MessageBox({
            //     type: 'error',
            //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
            //     dangerouslyUseHTMLString:true
            // });
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${error.response.data.path}` ,
                dangerouslyUseHTMLString:true
            });
        break;
    }
    return Promise.reject(error);
});

const axioscBody = axios.create({
    // baseURL: 'http://192.168.2.68/economic/review/server/',//朱庆请求地址
	baseURL: API.baseReviewURL,//朱庆请求地址
    timeout: 500000,
});
// axioscBody.defaults.withCredentials = true;
// 请求拦截
axioscBody.interceptors.request.use(function (config) {
    // Do something before request is sent
    let token = store.state.user.token;

    if (token) {
        config.headers['Authorization']=`Bearer ${token}`;
        // config.headers = {
        //   'Authorization': `Bearer ${token}`,
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // }
    }
    return config;
    }, function (error) {
    // Do something with request error
    //做登录拦截
    return Promise.reject(error);
});

// 响应拦截
axioscBody.interceptors.response.use(function (response) {
      // Do something with response data
      const res = response.data
      if(res.code === 200){
          return response.data;
      }else{
        switch(res.code){
          case 400:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 401:
          case 403:
        Vue.prototype.$message.closeAll();
        Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
        setTimeout(() => {
          window.localStorage.clear();
          store.commit({
            type:'user/loginOut'
          })
          router.push({
              path:'/login'
          })
        }, 1500)
        
          break;
          case 404:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
                  dangerouslyUseHTMLString:true
              });
              
          break;
          case 500:
              MessageBox({
                  type: 'error',
                  message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
                  dangerouslyUseHTMLString:true
              });
          break;
        }
        if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
          return Promise.reject(new Error(res.msg || 'Error'))
        }else return  res
      }
    }, function (error) {
		Vue.prototype.$message.closeAll();
    const code = error.response && error.response.status?error.response.status:error
    // Do something with response error
    switch(code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 401:
        case 403:
			Vue.prototype.$message.closeAll();
			Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
			setTimeout(() => {
				window.localStorage.clear();
        store.commit({
          type:'user/loginOut'
        })
				router.push({
				    path:'/login'
				})
			}, 1500)
            // MessageBox({
            //     type: 'error',
            //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
            //     dangerouslyUseHTMLString:true
            // });
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${error.response.data.path}` ,
                dangerouslyUseHTMLString:true
            });
        break;
    }
    return Promise.reject(error);
});


const axioszBody = axios.create({
    // baseURL: 'http://192.168.2.68/economic/review/server/',//朱庆请求地址
	 baseURL: API.baseReviewURL,//朱庆请求地址
    timeout: 500000,
});
// axioszBody.defaults.withCredentials = true;
// 请求拦截
axioszBody.interceptors.request.use(function (config) {
    // Do something before request is sent
    let token = store.state.user.token;

    if (token) {
        config.headers['Authorization']=`Bearer ${token}`;
        // config.headers = {
        //   'Authorization': `Bearer ${token}`,
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // }
    }
    return config;
    }, function (error) {
    // Do something with request error
    //做登录拦截
    return Promise.reject(error);
});

// 响应拦截
axioszBody.interceptors.response.use(function (response) {
    // Do something with response data
    const res = response.data
    if(res.code === 200){
        return response.data;
    }else{
      switch(res.code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
                dangerouslyUseHTMLString:true
            });
            
        break;
        case 401:
        case 403:
      Vue.prototype.$message.closeAll();
      Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
      setTimeout(() => {
        window.localStorage.clear();
        store.commit({
          type:'user/loginOut'
        })
        router.push({
            path:'/login'
        })
      }, 1500)
      
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
                dangerouslyUseHTMLString:true
            });
            
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
                dangerouslyUseHTMLString:true
            });
        break;
      }
      if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
        return Promise.reject(new Error(res.msg || 'Error'))
      }else return  res
    }
    }, function (error) {
		Vue.prototype.$message.closeAll();
    const code = error.response && error.response.status?error.response.status:error
    // Do something with response error
    switch(code){
        case 400:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 401:
        case 403:
			Vue.prototype.$message.closeAll();
			Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
			setTimeout(() => {
				window.localStorage.clear();
        store.commit({
          type:'user/loginOut'
        })
				router.push({
				    path:'/login'
				})
			}, 1500)
            // MessageBox({
            //     type: 'error',
            //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
            //     dangerouslyUseHTMLString:true
            // });
        break;
        case 404:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${error.response.data.path}`,
                dangerouslyUseHTMLString:true
            });
        break;
        case 500:
            MessageBox({
                type: 'error',
                message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${error.response.data.path}` ,
                dangerouslyUseHTMLString:true
            });
        break;
    }
    return Promise.reject(error);
});


const axioszBodys = axios.create({
  // baseURL: 'http://192.168.2.68/economic/review/server/',//朱庆请求地址
 baseURL: API.baseDataURL,//朱庆请求地址
  timeout: 500000,
});
// axioszBody.defaults.withCredentials = true;
// 请求拦截
axioszBodys.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token = store.state.user.token;

  if (token) {
      config.headers['Authorization']=`Bearer ${token}`;
      // config.headers = {
      //   'Authorization': `Bearer ${token}`,
      //   'Content-Type': 'application/x-www-form-urlencoded'
      // }
  }
  return config;
  }, function (error) {
  // Do something with request error
  //做登录拦截
  return Promise.reject(error);
});

// 响应拦截
axioszBodys.interceptors.response.use(function (response) {
  // Do something with response data
  const res = response.data
  if(res.code === 200){
      return response.data;
  }else{
    switch(res.code){
      case 400:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${response.config.url}`,
              dangerouslyUseHTMLString:true
          });
          
      break;
      case 401:
      case 403:
    Vue.prototype.$message.closeAll();
    Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
    setTimeout(() => {
      window.localStorage.clear();
      store.commit({
        type:'user/loginOut'
      })
      router.push({
          path:'/login'
      })
    }, 1500)
    
      break;
      case 404:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${response.config.url}`,
              dangerouslyUseHTMLString:true
          });
          
      break;
      case 500:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${response.config.url}` ,
              dangerouslyUseHTMLString:true
          });
      break;
    }
    if(res.code === 400 || res.code === 401 || res.code === 403 || res.code === 404 || res.code === 500){
      return Promise.reject(new Error(res.msg || 'Error'))
    }else return  res
  }
  }, function (error) {
  Vue.prototype.$message.closeAll();
  const code = error.response && error.response.status?error.response.status:error
  // Do something with response error
  switch(code){
      case 400:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码400！<br />原因：数据格式错误(确认是否使用qs转换表单提交)！<br />错误接口：${error.response.data.path}`,
              dangerouslyUseHTMLString:true
          });
      break;
      case 401:
      case 403:
    Vue.prototype.$message.closeAll();
    Vue.prototype.$message.error('身份信息出现错误，即将重新登录...');
    setTimeout(() => {
      window.localStorage.clear();
      store.commit({
        type:'user/loginOut'
      })
      router.push({
          path:'/login'
      })
    }, 1500)
          // MessageBox({
          //     type: 'error',
          //     message:`服务器连接失败，失败码401！<br />原因：授权错误（确认请求拦截的token是否错误）！<br />错误接口：${error.response.data.path}`,
          //     dangerouslyUseHTMLString:true
          // });
      break;
      case 404:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码404！<br />原因：服务器地址错误！<br />错误接口：${error.response.data.path}`,
              dangerouslyUseHTMLString:true
          });
      break;
      case 500:
          MessageBox({
              type: 'error',
              message:`服务器连接失败，失败码500！<br />原因：服务端代码错误!<br />错误接口：${error.response.data.path}` ,
              dangerouslyUseHTMLString:true
          });
      break;
  }
  return Promise.reject(error);
});
//字典表

let getDict = function (dictType, type) {
    let promise = [];
    let distIdAr = dictType;
    if (Array.isArray(dictType)) {

    } else {
        distIdAr = [dictType];
    }
    promise = distIdAr.map(d => {
        return axiosz.get("backstage/sysDict/"+dictType).then((res) => {
            if (res.code === 200) {
                return {
                    id: dictType,
                    data: (res.data || []).map(t => {
                        return Object.assign({}, t, {
                            value: t["value"],
                            name: t["name"]
                        })
                    })
                }
            } else {
                return null
            }
        })
    })
    return Promise.all(promise).then(data => {
        let res = {};
        (data || []).forEach(d => {
            if (d) {
                res[d.id] = d.data;
            }
        })
        return res;
    })
}

export {axios,axiosz,axiosc,getDict ,axioscBody,axioszBody,axioszBodys};
